// import React, { useState, useEffect } from "react";
// import { Table, Button, Modal, Form } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { IoTrashOutline } from "react-icons/io5";
// import axios from "../../../helper/axios";
// import { useUser } from "../../../Provider";
// import { Helmet } from "react-helmet";
// import { NavLink, useHistory } from "react-router-dom";
// import MUIDataTable from "mui-datatables";
// import { FaEdit } from "react-icons/fa";
// import { IconButton } from "@mui/material";
// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';
// const ListViewPathologyCategory = () => {
//   // Destructuring values from useUser hook
//   const { user, userHospitalcode, userrole1, isAuthRole, isAuthorized, gettokenId, token } = useUser();
//   // console.log(user, userHospitalcode, userrole1, isAuthRole, isAuthorized, gettokenId);
//   const history = useHistory();
//   const [data, setData] = useState([]);
//   const currentDate = new Date();
//   const day = currentDate.getDate();
//   const month = currentDate.getMonth() + 1; // Months are zero-indexed, so add 1
//   const year = currentDate.getFullYear();
//   // Format the date as DD-MM-YYYY
//   const formattedDate = `${day}-${month}-${year}`;
//   // const token = sessionStorage.getItem("jwtToken");
//   const [userRole, setRole] = useState();

//   // When the page loads or refreshes, this function will be called
//   useEffect(() => {
//     const loadData = async () => {
//       // await loadAllDetails();
//       // loadAllAppointment(); will wait for loadAllDetails(); to be executed
//       await loadAllCategory();
//     };

//     loadData();
//   }, [userHospitalcode, userrole1, isAuthorized]);

//   // Load all categories based on user role and hospital code
//   const loadAllCategory = async () => {
//     try {
//       if (userHospitalcode !== undefined && userrole1 !== undefined) {
//         console.log("userHospitalcode:", userHospitalcode); // Add this line
//         console.log("userrole1:", userrole1); // Add this line
//         const res = await axios.get("/getpathologycategory", {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//           params: {
//             hospitalcode: userHospitalcode, // Include the hospital code in the query parameters
//             userrole: userrole1, // Include the user role in the query parameters
//           },
//         });
//         setData(res.data);
//         console.log(res.data);
//       }
//     } catch (error) {
//       // Handle any error here.
//       alert("Error deleting hospital:", error);
//     }
//   };

//   const cancelcategory = async (categoryid) => {
//     // Display a confirmation dialog
//     const isConfirmed = window.confirm("Do you want to cancel this category?");

//     if (isConfirmed) {
//       try {
//         await axios.post(`/cancelcategoryname/${categoryid}`, null, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         loadAllCategory();
//         //alert("Bill has been canceled.");

//         // After successfully canceling the bill, refresh the bill list.
//       } catch (error) {
//         // Handle any error here.
//         alert("Error Cancelling Unit:", error);
//       }
//     } else {
//       // User clicked "Cancel" in the confirmation dialog, do nothing.
//     }
//   };
//   // Define columns for MUIDataTable based on user authorization
//   let columns;
//   if (isAuthorized) {
//     columns = [
//       {
//         name: "chargetype",
//         label: "Charges Type",
//         options: {
//           filter: true,
//           sort: true,
//         },
//       },
//       {
//         name: "categoryname",
//         label: "Category Name",
//         options: {
//           filter: true,
//           sort: true,
//         },
//       },
//       {
//         name: "tax",
//         label: "Charge Tax",
//         options: {
//           filter: true,
//           sort: true,
//         },
//       },
//       {
//         name: "chargeamount",
//         label: "Charge Amount",
//         options: {
//           filter: true,
//           sort: true,
//         },
//       },
//       {
//         name: "hospitalcode",
//         label: "Hospital Code",
//         options: {
//           filter: true,
//           sort: true,
//           customBodyRender: (value) => (value !== null && value !== undefined) ? value.toString().padStart(5, '0') : ""
//         },
//       },
//       {
//         name: "",
//         label: "",
//         options: {
//           customBodyRender: (value, tableMeta, updateValue) => {
//             const newD = data.find((e) => {
//               return (
//                 e.chargetype === tableMeta.rowData[0] &&
//                 e.categoryname === tableMeta.rowData[1]&&
//                 e.tax === tableMeta.rowData[2]&&
//                 e.chargeamount === tableMeta.rowData[3]&&
//                 e.hospitalcode === tableMeta.rowData[4]
//               );
//             });
//             return (
//               <>
//                <IconButton color="secondary" onClick={() => cancelcategory(newD.categoryid)}>
//                 <DeleteIcon/>
//               </IconButton>
//               <NavLink to={`/editpathologycategory/${newD.chargecode}`}>
//               <IconButton  color="primary">
//               <EditIcon/>
//               </IconButton>
//               </NavLink>
//               </>
//             );
//           },
//         },
//       },
//     ];
//   } else {
//     columns = [
//       {
//         name: "chargetype",
//         label: "Charges Type",
//         options: {
//           filter: true,
//           sort: true,
//         },
//       },
//       {
//         name: "categoryname",
//         label: "Category Name",
//         options: {
//           filter: true,
//           sort: true,
//         },
//       },
//       {
//         name: "tax",
//         label: "Charge Tax",
//         options: {
//           filter: true,
//           sort: true,
//         },
//       },
//       {
//         name: "chargeamount",
//         label: "Charge Amount",
//         options: {
//           filter: true,
//           sort: true,
//         },
//       },

//       {
//         name: "",
//         label: "",
//         options: {
//           customBodyRender: (value, tableMeta, updateValue) => {
//             const newD = data.find((e) => {
//               return (
//                 e.chargetype === tableMeta.rowData[0] &&
//                 e.categoryname === tableMeta.rowData[1]&&
//                 e.tax === tableMeta.rowData[2]&&
//                 e.chargeamount === tableMeta.rowData[3]

//               );
//             });
//             return (
//               <>
//                <IconButton color="secondary" onClick={() => cancelcategory(newD.categoryid)}>
//                 <DeleteIcon/>
//               </IconButton>
//               <NavLink to={`/editpathologycategory/${newD.chargecode}`}>
//               <IconButton  color="primary">
//               <EditIcon/>
//               </IconButton>
//               </NavLink>
//               </>
//             );
//           },
//         },
//       },
//     ];
//   }

//   const options = {
//     selectableRows: false,
//     onRowClick: ((props) => {
//       console.log(props);
//     }),
//     downloadOptions: {
//       filename: `Patient_list_${formattedDate}`, // Customize the filename here to download
//       filterOptions: {
//         useDisplayedColumnsOnly: true,
//         useDisplayedRowsOnly: true,
//       },
//     },
//   };

//   const currentDomain = window.location.hostname;

//   return (
//     <>
//       <Helmet>
//         <title>Aarogyasaarthi | {currentDomain} Category List</title>
//       </Helmet>
//       <NavLink to='/addpathologycategory'>
//         <button className="btn btn-success btn-sm mr-2" style={{ margin: "10px" }}>
//           <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" style={{ paddingRight: '4px' }} viewBox="0 0 100 100">
//             <line x1="10" y1="50" x2="90" y2="50" stroke="white" stroke-width="10" />
//             <line x1="50" y1="10" x2="50" y2="90" stroke="white" stroke-width="10" />
//           </svg>Add Pathology Category
//         </button>
//       </NavLink>
//       <MUIDataTable
//         title={"Pathology Category List"}
//         data={data}
//         columns={columns}
//         options={options}
//         className="custom-mui-datatable"
//       />
//     </>
//   );
// };

// export default ListViewPathologyCategory;

import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoTrashOutline } from "react-icons/io5";
import axios from "../../../helper/axios";
import { useUser } from "../../../Provider";
import { Helmet } from "react-helmet";
import { NavLink, useHistory } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import { FaEdit } from "react-icons/fa";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useToast } from "../../ToastSystem";
import { useConfirmation } from "../../ConfirmationModal";

const ListViewPathologyCategory = () => {
  const {
    user,
    userHospitalcode,
    userrole1,
    isAuthRole,
    isAuthorized,
    gettokenId,
    token,
  } = useUser();
  const { showSuccess, showError } = useToast();
  const { showConfirmation } = useConfirmation();

  const history = useHistory();
  const [data, setData] = useState([]);
  const currentDate = new Date();
  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1;
  const year = currentDate.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;
  const [userRole, setRole] = useState();

  useEffect(() => {
    const loadData = async () => {
      await loadAllCategory();
    };
    loadData();
  }, [userHospitalcode, userrole1, isAuthorized]);

  const loadAllCategory = async () => {
    try {
      if (userHospitalcode !== undefined && userrole1 !== undefined) {
        console.log("userHospitalcode:", userHospitalcode);
        console.log("userrole1:", userrole1);
        const res = await axios.get("/getpathologycategory", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            hospitalcode: userHospitalcode,
            userrole: userrole1,
          },
        });
        setData(res.data);
        console.log(res.data);
      }
    } catch (error) {
      console.error("Error loading pathology categories:", error);

      if (error.response?.status === 404) {
        showError("No pathology categories found.");
      } else if (error.response?.status === 403) {
        showError("Unauthorized access. You don't have permission.");
      } else if (error.response?.status >= 500) {
        showError("Server error occurred. Please try again later.");
      } else if (error.request) {
        showError("Network error. Please check your connection and try again.");
      } else {
        showError("Failed to load pathology categories. Please try again.");
      }
    }
  };

  const cancelcategory = async (categoryid, categoryname) => {
    try {
      const confirmed = await showConfirmation({
        title: "Cancel Pathology Category",
        message: `Are you sure you want to cancel the category "${categoryname}"? This action cannot be undone.`,
        confirmText: "Cancel Category",
        cancelText: "Keep Category",
        type: "danger",
      });

      if (!confirmed) return;

      await axios.post(`/cancelcategoryname/${categoryid}`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      showSuccess(
        `Category "${categoryname}" has been successfully cancelled!`
      );
      loadAllCategory();
    } catch (error) {
      console.error("Error cancelling category:", error);

      if (error.response?.status === 404) {
        showError("Category not found. It may have already been cancelled.");
      } else if (error.response?.status === 403) {
        showError("You don't have permission to cancel this category.");
      } else if (error.response?.status >= 500) {
        showError("Server error occurred. Please try again later.");
      } else if (error.request) {
        showError("Network error. Please check your connection and try again.");
      } else {
        showError("Failed to cancel category. Please try again.");
      }
    }
  };

  let columns;
  if (isAuthorized) {
    columns = [
      {
        name: "chargetype",
        label: "Charges Type",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "categoryname",
        label: "Category Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "tax",
        label: "Charge Tax",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "chargeamount",
        label: "Charge Amount",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "hospitalcode",
        label: "Hospital Code",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value !== null && value !== undefined
              ? value.toString().padStart(5, "0")
              : "",
        },
      },
      {
        name: "",
        label: "Action",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            const newD = data.find((e) => {
              return (
                e.chargetype === tableMeta.rowData[0] &&
                e.categoryname === tableMeta.rowData[1] &&
                e.tax === tableMeta.rowData[2] &&
                e.chargeamount === tableMeta.rowData[3] &&
                e.hospitalcode === tableMeta.rowData[4]
              );
            });
            return (
              <>
                <IconButton
                  color="secondary"
                  onClick={() =>
                    cancelcategory(newD.categoryid, newD.categoryname)
                  }
                >
                  <DeleteIcon />
                </IconButton>
                <NavLink to={`/editpathologycategory/${newD.chargecode}`}>
                  <IconButton color="primary">
                    <EditIcon />
                  </IconButton>
                </NavLink>
              </>
            );
          },
        },
      },
    ];
  } else {
    columns = [
      {
        name: "chargetype",
        label: "Charges Type",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "categoryname",
        label: "Category Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "tax",
        label: "Charge Tax",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "chargeamount",
        label: "Charge Amount",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "",
        label: "Action",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            const newD = data.find((e) => {
              return (
                e.chargetype === tableMeta.rowData[0] &&
                e.categoryname === tableMeta.rowData[1] &&
                e.tax === tableMeta.rowData[2] &&
                e.chargeamount === tableMeta.rowData[3]
              );
            });
            return (
              <>
                <IconButton
                  color="secondary"
                  onClick={() =>
                    cancelcategory(newD.categoryid, newD.categoryname)
                  }
                >
                  <DeleteIcon />
                </IconButton>
                <NavLink to={`/editpathologycategory/${newD.chargecode}`}>
                  <IconButton color="primary">
                    <EditIcon />
                  </IconButton>
                </NavLink>
              </>
            );
          },
        },
      },
    ];
  }

  const options = {
    selectableRows: false,
    onRowClick: (props) => {
      console.log(props);
    },
    downloadOptions: {
      filename: `Pathology_Category_${formattedDate}`,
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
  };

  const currentDomain = window.location.hostname;

  return (
    <>
      <Helmet>
        <title>
          Pathology Category List | {currentDomain} | Hospital Management
          Software | Smart Solutions for Hospital Efficiency
        </title>
      </Helmet>
      <NavLink to="/addpathologycategory">
        <button
          className="btn btn-success btn-sm mr-2"
          style={{ margin: "10px" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="18"
            style={{ paddingRight: "4px" }}
            viewBox="0 0 100 100"
          >
            <line
              x1="10"
              y1="50"
              x2="90"
              y2="50"
              stroke="white"
              strokeWidth="10"
            />
            <line
              x1="50"
              y1="10"
              x2="50"
              y2="90"
              stroke="white"
              strokeWidth="10"
            />
          </svg>
          Add Pathology Category
        </button>
      </NavLink>
      <MUIDataTable
        title={"Pathology Category List"}
        data={data}
        columns={columns}
        options={options}
        className="custom-mui-datatable"
      />
    </>
  );
};

export default ListViewPathologyCategory;
